import {FC, useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import {saveToLocalStorage} from 'global/utils/storage';

interface Props {
    children: any,
    keys: { name: string, storePath: string; }[]
};
export const SaveRouteParams: FC<Props> = ({children, keys = []}) => {
    const params = useParams();
    const [isFinish, setIsFinish] = useState(false);

    useEffect(() => {
        keys.forEach(key => {
            const value = params[key.name];

            if (value) {
                saveToLocalStorage(key.storePath, value);
            }
        });

        setIsFinish(true);
    }, []);

    return isFinish && children;
};
